import { gql } from '@apollo/client';

export const POLL_EVENTS = gql`
  query pollEvents(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: EventsFilterInput
    $schemeId: String!
  ) {
    events(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      schemeId: $schemeId
    ) {
      edges {
        node {
          ... on CandidateApplicationCreatedEvent {
            __typename
            candidateId
            candidateApplicationProfileId
          }
          ... on CandidateProfilePurchasedEvent {
            __typename
            candidateProfileId
          }
          ... on HirerRelationshipChangedEvent {
            __typename
            hirerId
          }
          ... on PositionNotPostedEvent {
            __typename
            reasonId
            seekPartnerPositionId
          }
          ... on PositionProfileClosedEvent {
            __typename
            positionProfileId
          }
          ... on PositionProfilePostedEvent {
            __typename
            positionProfileId
          }
          ... on PositionProfileUpdatedEvent {
            __typename
            positionProfileId
          }
          id {
            value
          }
          createDateTime
          typeCode
          schemeId
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
